<script setup>
import { Button } from '@dashhudson/dashing-ui/button';
import { Menu } from '@dashhudson/dashing-ui/menu';
import { computed, defineAsyncComponent, markRaw, toRefs } from 'vue';
import { useAddToSchedulerActions } from '@/app/scheduler/composables/useAddToSchedulerActions';
import {
  pinterestMediaCountLimit,
  pinterestMediaCountLimitMessage,
} from '@/app/scheduler/constants';

const props = defineProps({
  selectedMedia: { type: Array, required: true },
  showDropdown: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  tooltip: { type: String, default: 'Schedule Media' },
});

const { selectedMedia } = toRefs(props);

const emit = defineEmits(['onActionComplete', 'mediaScheduled']);

const { handleAddToUnscheduled, handleSchedulePinterest } = useAddToSchedulerActions(selectedMedia);

const exceedsPinterestLimit = computed(() => selectedMedia.value.length > pinterestMediaCountLimit);

async function addSelectedMediaToUnscheduled(selectedChannels) {
  await handleAddToUnscheduled(selectedChannels);
  emit('onActionComplete');
  emit('mediaScheduled', selectedChannels);
}

const addToSchedulerMenuOptions = computed(() => [
  {
    icon: 'pinterest-color',
    label: 'Pinterest Pins',
    command: handleSchedulePinterest,
    disabled: exceedsPinterestLimit.value,
    tooltip: exceedsPinterestLimit.value ? pinterestMediaCountLimitMessage : undefined,
  },
  {
    icon: 'calendar-plus',
    label: 'Unscheduled',
    command: addSelectedMediaToUnscheduled,
    form: markRaw(
      defineAsyncComponent(() => import('@/components/AddToUnscheduledSelectList.vue')),
    ),
    formProps: {
      selectedMedia: props.selectedMedia,
    },
  },
]);
</script>

<template>
  <Menu :model="addToSchedulerMenuOptions" :dropdown="{ placement: 'bottom-end' }">
    <Button
      v-dash-tooltip="props.tooltip"
      size="xs"
      severity="bulk"
      icon="calendar"
      :disabled="props.disabled"
    />
  </Menu>
</template>
